import {connect} from '@viskan/deku-redux';
import ImageComponent from './components/image';

export const Image = connect(state => ({mediaConfig: state.site.mediaConfig}))(ImageComponent);
